var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_666_8890",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_666_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 9C17.4727 13.6793 13.6793 17.4727 9 17.4727C4.3206 17.4727 0.527344 13.6793 0.527344 9C0.527344 4.3206 4.3206 0.527344 9 0.527344C13.6793 0.527344 17.4727 4.3206 17.4727 9Z",
    stroke: "black",
    strokeWidth: 1.36719,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.389 7.87021C12.389 9.74193 10.8717 11.2593 8.99994 11.2593C7.12808 11.2593 5.61084 9.74193 5.61084 7.87021C5.61084 5.99853 7.12808 4.48119 8.99994 4.48119C10.8717 4.48119 12.389 5.99853 12.389 7.87021Z",
    stroke: "black",
    strokeWidth: 1.36719,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94531 15.7997C4.21637 13.2473 6.37609 11.259 9.00032 11.259C11.6246 11.259 13.7843 13.2475 14.0553 15.7998",
    stroke: "black",
    strokeWidth: 1.36719,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiProfileIcon);
export default __webpack_public_path__ + "static/media/tildi-profile-icon.ac75d57e4ec810b200c18f4e8d1c841f.svg";
export { ForwardRef as ReactComponent };